import { Controller } from "@hotwired/stimulus"

// Keeps the export link's date params in sync with the current
// values of the date inputs, even before the filter form is submitted.
export default class extends Controller {
  static targets = ["link"]
  static values = { baseUrl: String }

  updateHref() {
    if (!this.hasLinkTarget) return

    const dateInputs = this.element.querySelectorAll('input[type="date"]')
    if (dateInputs.length < 2) return

    const params = new URLSearchParams({
      start_date: dateInputs[0].value,
      end_date: dateInputs[1].value
    })
    this.linkTarget.href = `${this.baseUrlValue}?${params}`
  }
}
